import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import BackToTop from '../components/layout/BackToTop';
import privacyContent from '../content/privacy/index.json';
import { usePageMeta } from '../lib/usePageMeta';
import { AlertTriangle, ShieldCheck } from 'lucide-react';

const PrivacyPage = () => {
  usePageMeta(
    'Privacy Policy — ResiAX',
    'How ResiAX handles resident information in plain English: resident-owned accounts, provider sponsorship and data sharing, AI-supported features, and your UK GDPR rights.'
  );

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const d = privacyContent;

  return (
    <div className="min-h-screen bg-[#FFFAF8]">
      <Header />
      <main>
        <section className="pt-32 pb-12 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest font-bold text-[#B5541B] mb-4">
              <ShieldCheck className="w-4 h-4" />
              {d.hero.badge}
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-[#1F1E1E] leading-tight mb-4" data-testid="privacy-heading">
              {d.hero.title}
            </h1>
            <p className="text-lg text-[#3B3535]/75 leading-relaxed mb-6">
              {d.hero.intro}
            </p>
            <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="privacy-draft-notice">
              <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
              <p className="text-sm text-amber-800 leading-relaxed">{d.hero.draftNotice}</p>
            </div>
          </div>
        </section>

        <section className="py-14 bg-[#FFFAF8]">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
            {(d.sections || []).map((s) => (
              <div key={s.title} className="bg-white rounded-2xl p-7 shadow-sm border border-gray-100">
                <h2 className="text-lg font-bold text-[#1F1E1E] mb-3">{s.title}</h2>
                {(s.body || []).map((p, i) => (
                  <p key={i} className="text-sm text-[#3B3535]/85 leading-relaxed mb-3 last:mb-0">{p}</p>
                ))}
              </div>
            ))}
            <p className="text-xs text-[#3B3535]/60 leading-relaxed px-2">{d.footnote}</p>
            <p className="text-sm text-[#3B3535]/70 px-2">
              Thinking about who could support you with a housing issue?{' '}
              <Link to="/residents#support" data-testid="privacy-support-link" className="font-semibold text-[#B5541B] hover:text-[#8B3F14] transition-colors">
                Learn about resident support
              </Link>
            </p>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default PrivacyPage;
